// Generic behaviour to disable the submit button when required fields within the same container are empty
import debounce from 'lodash/debounce'

const BEHAVIOUR_SELECTOR = '[data-behaviour="validate-required-fields"]'
const REQUIRED_FIELDS_SELECTOR = '.sf-form-input.required'
const SUBMIT_BUTTON_SELECTOR = '[type="submit"]'

const applySubmitClass = (anyEmptyFn, submitButton) => {
  const submitButtonParent = submitButton.parentElement

  window.requestAnimationFrame(() => {
    if (anyEmptyFn()) {
      submitButton.classList.add('sf-disabled')

      const { title } = submitButtonParent.dataset
      if (title) {
        submitButtonParent.title = title
      }
    } else {
      submitButton.classList.remove('sf-disabled')
      submitButtonParent.title = ''
    }
  })
}

export default () => {
  onDomLoad((jqueryDom) => {
    const $dom = jqueryDom[0]

    const container =
      ($dom.matches && $dom.matches(BEHAVIOUR_SELECTOR) && $dom) ||
      $dom.querySelector(BEHAVIOUR_SELECTOR)

    if (!container) {
      return
    }

    const submitButton = container.querySelector(SUBMIT_BUTTON_SELECTOR)

    if (!submitButton) {
      return
    }

    const requiredTextFields = container.querySelectorAll(
      `${REQUIRED_FIELDS_SELECTOR}.text`
    )
    const requiredFileFields = container.querySelectorAll(
      `${REQUIRED_FIELDS_SELECTOR}.file`
    )

    const anyEmpty = () =>
      Array.from(requiredTextFields).some((f) => !f.value) ||
      Array.from(requiredFileFields).some((f) => !f.files.length)

    // apply initially
    applySubmitClass(anyEmpty, submitButton)

    // apply on keyup of all required text inputs
    requiredTextFields.forEach((requiredField) => {
      requiredField.addEventListener(
        'keyup',
        debounce(() => applySubmitClass(anyEmpty, submitButton), 200, {
          leading: true,
        })
      )
    })

    // apply on change of all required file inputs
    requiredFileFields.forEach((requiredField) => {
      requiredField.addEventListener('change', () => {
        applySubmitClass(anyEmpty, submitButton)
      })
    })
  })
}
